// tslint:disable
/**
 * JLIVE ADMIN API
 * JLIVE ADMIN API
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { QuestionOptionCreateUpdate } from '.';

/**
 * @export
 * @interface QuestionCreateUpdate
 */
export interface QuestionCreateUpdate {
  /**
   * @type {number}
   * @memberof QuestionCreateUpdate
   */
  id?: number;
  /**
   * @type {string}
   * @memberof QuestionCreateUpdate
   */
  text: string;
  /**
   * @type {string}
   * @memberof QuestionCreateUpdate
   */
  description?: string;
  /**
   * @type {string}
   * @memberof QuestionCreateUpdate
   */
  type?: QuestionCreateUpdateTypeEnum;
  /**
   * @type {Array<QuestionOptionCreateUpdate>}
   * @memberof QuestionCreateUpdate
   */
  options?: Array<QuestionOptionCreateUpdate>;
  /**
   * @type {string}
   * @memberof QuestionCreateUpdate
   */
  readonly slug?: string;
  /**
   * @type {boolean}
   * @memberof QuestionCreateUpdate
   */
  is_required?: boolean;
  /**
   * @type {boolean}
   * @memberof QuestionCreateUpdate
   */
  is_options_custom_text_allowed?: boolean;
}

/**
 * @export
 * @enum {string}
 */
export enum QuestionCreateUpdateTypeEnum {
  Single = 'single',
  Multiple = 'multiple',
  Paragraph = 'paragraph',
  Text = 'text',
  Custom = 'custom',
}
